import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import VisioDiagnostic from "./components/VisioDiagnostic";
import AvisGoogle from "./components/AvisGoogle";
import Realisations from "./components/Realisations";
import CTA from "./components/CTA";
import Formulaire from "./components/Formulaire";
import Maillage from "./components/Maillage";
import Avis from "@/components/feature/Avis";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingButton";

export default function AvisPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Avis Clients Volet Roulant Strasbourg | Dépan'Volets"
        description="Avis clients Dépan'Volets à Strasbourg et dans le Bas-Rhin. Réparation et motorisation de volets roulants, toutes marques. Devis gratuit. 03 74 47 32 40."
        path="/avis"
        type="website"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Avis clients" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Avis clients" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <VisioDiagnostic />
        <AvisGoogle />
        <Realisations />
        <CTA />
        <Formulaire />
        <Maillage />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}